import { toKebabCase } from "../../../lib/toKebabCase";
var prefix = "data-visual-state-";

function fillResult(result, key, value) {
  if (value !== null && value !== undefined) {
    result["" + prefix + toKebabCase(key)] = String(value);
  }

  return result;
}

export function getVisualStateDataAttributes(attributes) {
  return Object.entries(attributes).reduce(function (previousValue, currentValue) {
    return fillResult(previousValue, currentValue[0], currentValue[1]);
  }, {});
}